import React from "react";
import { Box, Divider, Typography, useMediaQuery, useTheme } from "@mui/material";

/**
 * 메인 상단 탭 (방송/홍보영상/디지털콘텐츠/오프라인행사)
 *
 * @param {Object} props
 *  - tabData: [{label, contentId}, ...]
 *  - currentTabIndex: 선택된 탭 인덱스
 *  - onChangeTab: (index) => void
 */
const TabNavigation = ({ tabData, currentTabIndex, onChangeTab }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box
        component="ul"
        sx={{
          display: "flex",
          flexWrap: "wrap", // 화면이 좁을 때 자동 줄바꿈
          justifyContent: "center",
          borderBottom: "1px solid #d9d9d9",
          padding: 0,
          listStyle: "none",
        }}
      >
        {tabData.map((tab, idx) => (
          <Box
            component="li"
            key={tab.contentId}
            sx={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              marginBottom: isMobile ? "0.3125rem" : "0", // 5px
            }}
          >
            <Typography
              component="a"
              href="#!"
              onClick={(e) => {
                e.preventDefault();
                onChangeTab(idx);
              }}
              sx={{
                display: "inline-block",
                fontSize: isMobile ? "0.8rem" : "1.3rem", // 14px : 20px
                color: idx === currentTabIndex ? "#d82828" : "#666",
                lineHeight: isMobile ? "3rem" : "4.3rem", // 48px : 69px
                textDecoration: "none",
                fontWeight: "normal",
                transition: "color 0.3s ease-in-out",
                padding: isMobile ? "0 0.625rem" : "0 0.9375rem", // 10px : 15px
                position: "relative",
                cursor: "pointer",
              }}
            >
              {tab.label}
              <Box
                className="underline"
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  height: "2px",
                  background: "#d82828",
                  transform: idx === currentTabIndex ? "scaleX(1)" : "scaleX(0)",
                  transformOrigin: "center",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            </Typography>
            {idx < tabData.length - 1 && (
              <Typography
                component="span"
                sx={{
                  margin: isMobile ? "0 0.3125rem" : "0 0.625rem", // 5px : 10px
                  color: "#999",
                  fontSize: isMobile ? "0.9rem" : "1.3rem",
                  pointerEvents: "none",
                  userSelect: "none",
                }}
              >
                ·
              </Typography>
            )}
          </Box>
        ))}
      </Box>
      <Divider sx={{ width: "100%" }} />
    </>
  );
};

export default TabNavigation;
